import React from "react";
import { Descriptions } from "antd";
import { DateFormat } from "../date/DateFormat.jsx";
import { $t, i18n } from "~/i18n.js";
import { VoucherBalanceStatus } from "./VoucherBalanceStatus.jsx";
import { ExtrasDescription } from "../form/extras.jsx";

export function VoucherInfo({ voucher }) {
  if (!voucher) return null;
  console.log("voucher ", { voucher });
  return (
    <section>
      <Descriptions column={1} size="small" bordered={false}>
        <Descriptions.Item label={$t("Gereserveerde tijdslot")}>
          {voucher.reserved_timeslot ? (
            <DateFormat
              date={voucher.reserved_timeslot}
              options={{
                weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              }}
            />
          ) : (
            <span>{$t("Geen gereserveerde tijdslot")}</span>
          )}
        </Descriptions.Item>

        <Descriptions.Item label={$t("Geserveerveerd door")}>
          {voucher.name}
        </Descriptions.Item>

        <Descriptions.Item label={$t("Telefoonnummer")}>
          {voucher.phone}
        </Descriptions.Item>

        {voucher.gift_name && (
          <Descriptions.Item label={$t("Kado voor")}>
            {voucher.gift_name}
          </Descriptions.Item>
        )}

        <Descriptions.Item label={$t("Opmerking")}>
          {voucher.remark}
        </Descriptions.Item>
        {voucher.ledger_balance !== undefined && (
          <Descriptions.Item label={$t("Saldo")}>
            <p className="row" style={{ gap: 6 }}>
              <VoucherBalanceStatus balance={voucher.ledger_balance} />{" "}
              {i18n.parseLocaleCurrencyString(voucher?.ledger_balance || 0)}
            </p>
          </Descriptions.Item>
        )}
      </Descriptions>

      {voucher?.extra && voucher?.prepaid_product?.extras && (
        <ExtrasDescription
          extraData={voucher?.extra}
          extras={voucher?.prepaid_product?.extras}
        />
      )}

      {voucher?.gift_name && voucher?.prepaid_product?.extras_guest?.length > 0 && (
        <ExtrasDescription
          extraData={voucher.extra_guest || {}}
          extras={voucher.prepaid_product.extras_guest}
        />
      )}
    </section>
  );
}
